<template>
	<li v-for="item in items" :key="item.name">
		<router-link
			v-if="item.visible"
			:to="item.href"
			class="menu-item items-center"
			data-testid="menu-item"
			:class="[
				item.current
					? 'bg-mabey-950 text-white'
					: 'text-mabey-950 hover:text-white hover:bg-mabey-500',
				'relative group flex gap-x-3 rounded-md pl-[33px] pr-2 py-2 text-sm leading-6 font-semibold min-h-[40px]'
			]"
			@click="handleMenuClick">
			<font-awesome-icon
				:icon="item.icon"
				:class="[
					item.current ? 'text-white' : 'text-mabey-950 group-hover:text-white',
					'h-4 left-3 w-4 shrink-0 absolute'
				]" />

			<span v-if="!compact" class="ml-2">{{ item.name }}</span>

			<span
				v-if="item.count && !compact"
				class="ml-auto w-9 min-w-max whitespace-nowrap rounded-full bg-mabey-950 px-2.5 py-0.5 text-center text-xs font-medium leading-5 text-white ring-none"
				aria-hidden="true"
				>{{ item.count }}</span
			>
		</router-link>
	</li>
</template>

<script lang="ts">
	import { computed } from 'vue'
	import useAppStore from '@/stores/app'

	export default {
		name: 'AppSidebarMenu',
		props: {
			items: {
				type: Object,
				default: undefined
			},
			compact: {
				type: Boolean,
				default: false
			}
		},
		setup() {
			const appStore = useAppStore()
			
			const desktop = computed(() => {
				return window.innerWidth > 1024
			})

			const handleMenuClick = () => {
				// Close sidebar on mobile after clicking a menu item
				if (!desktop.value && appStore.sidebar) {
					appStore.toggleSidebar()
				}
			}

			return {
				handleMenuClick
			}
		}
	}
</script>
